import { Controller } from '@hotwired/stimulus'
import {
  parseISO,
  isAfter,
  isBefore,
  isEqual
} from 'date-fns'
import { showElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ['notification', 'section', 'loadMoreButton']

  initialize() {
    this.indexedSections = {}
    this.indexedDateRanges = {}
    this.sectionTargets.forEach((section) => {
      this.indexedSections[section.dataset.jsNotificationSectionKey] = section
      this.indexedDateRanges[section.dataset.jsNotificationSectionKey] = {
        start: parseISO(section.dataset.jsNotificationSectionStart),
        end: parseISO(section.dataset.jsNotificationSectionEnd)
      }
    })

    this.lastNotificationSeenAt = parseISO(this.element.dataset.lastNotificationSeenAt)
    this.notificationTargets.forEach((el) => this.moveToAppropriateSection(el))
  }

  moveToAppropriateSection(notification) {
    const date = parseISO(notification.dataset.jsNotificationDate)
    const sectionKey = this.findSectionKeyForDate(date)
    const section = this.indexedSections[sectionKey]

    section.querySelector(".c-notifications").appendChild(notification)
    showElement(section)
  }

  findSectionKeyForDate(date) {
    if (isAfter(date, this.lastNotificationSeenAt)) return "new"

    const sectionKeys = Object.keys(this.indexedDateRanges)
    for (let i = 0; i < sectionKeys.length; i++) {
      const key = sectionKeys[i]
      const rangeStart = this.indexedDateRanges[key]["start"]
      const rangeEnd = this.indexedDateRanges[key]["end"]

      if ((isEqual(date, rangeEnd) || isBefore(date, rangeEnd)) &&
          (isEqual(date, rangeStart) || isAfter(date, rangeStart))) {
        return key
      }
    }

    throw new Error(`Couldn't find appropriate section for date ${date.toString()}`)
  }

  appendMoreResults({ detail: [response, status, xhr] }) {
    const domParser = new DOMParser()
    const resultsNodes = Array.from(domParser.parseFromString(response["results_html"], "text/html").body.childNodes)
    const lastNode = resultsNodes[resultsNodes.length - 1]

    resultsNodes.forEach((node) => {
      this.moveToAppropriateSection(node)
    })

    if (response["has_more"]) {
      this.loadMoreButtonTarget.href = `/notifications?before_time=${lastNode.dataset.jsNotificationDate}`
    } else {
      this.loadMoreButtonTarget.remove()
    }
  }
}
